(function () {
  var VENDOR_ID = '661';
  var ASSETS = {
    fontAwesome: 'https://cdn.bioz.com/assets/font-awesome-reg.css',
    tooltipster: 'https://cdn.bioz.com/assets/tooltipster.css',
    tooltipsterTheme: 'https://cdn.bioz.com/assets/tooltipster-theme2.css',
    widgetCss: 'https://cdn.bioz.com/assets/v_widget-2.5-1.css',
    api: 'https://cdn.bioz.com/assets/bioz-w-api-2.5.min.js',
    widget: 'https://cdn.bioz.com/assets/v_widget-2.5.pro_spec.js',
    tooltipsterJs: 'https://cdn.bioz.com/assets/tooltipster.js',
  };

  var depsPromise = null;

  function uniqueSkus(raw) {
    var seen = {};
    var out = [];
    String(raw || '')
      .split(',')
      .forEach(function (part) {
        var sku = part.trim().toLowerCase().replace(/\s+/g, '');
        if (sku && !seen[sku]) {
          seen[sku] = true;
          out.push(sku);
        }
      });
    return out;
  }

  function resolveSlug(root) {
    var override = (root.getAttribute('data-bioz-widget') || '').trim();
    if (override) return override;
    var map = window.BIOZ_SKU_MAP || {};
    var skus = uniqueSkus(root.getAttribute('data-bioz-skus'));
    for (var i = 0; i < skus.length; i++) {
      if (map[skus[i]]) return map[skus[i]];
    }
    return '';
  }

  function sanitizeId(value) {
    return String(value || '')
      .replace(/[ .]/g, '_')
      .replace(/[^a-zA-Z0-9_-]/g, '_');
  }

  function loadStylesheetOnce(href) {
    if (document.querySelector('link[href="' + href + '"]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  function loadScriptOnce(src) {
    return new Promise(function (resolve) {
      var existing = document.querySelector('script[src="' + src + '"]');
      if (existing) {
        if (existing.getAttribute('data-bioz-loaded') === 'true' || existing.dataset.biozLoaded === 'true') {
          resolve();
          return;
        }
        existing.addEventListener('load', resolve);
        existing.addEventListener('error', resolve);
        return;
      }
      var script = document.createElement('script');
      script.src = src;
      script.onload = function () {
        script.setAttribute('data-bioz-loaded', 'true');
        resolve();
      };
      script.onerror = resolve;
      document.head.appendChild(script);
    });
  }

  function ensureGlobals() {
    window._type = 'commercial';
    window._company = VENDOR_ID;
    window._vendor = 'ProSpec';
    window._vendor_partner_color = '#1f2860';
    window._form_url = 'https://back-badge-8.bioz.com';
    window._key = '';
    window._form_mobile = false;
  }

  function loadMicroDeps() {
    if (depsPromise) return depsPromise;
    loadStylesheetOnce(ASSETS.fontAwesome);
    loadStylesheetOnce(ASSETS.tooltipster);
    loadStylesheetOnce(ASSETS.tooltipsterTheme);
    loadStylesheetOnce(ASSETS.widgetCss);
    ensureGlobals();

    depsPromise = loadScriptOnce(ASSETS.api)
      .then(function () {
        return loadScriptOnce(ASSETS.widget);
      })
      .then(function () {
        return loadScriptOnce(ASSETS.tooltipsterJs);
      });

    return depsPromise;
  }

  function waitForJQuery() {
    return new Promise(function (resolve) {
      if (window.jQuery) {
        resolve(window.jQuery);
        return;
      }
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (window.jQuery || tries > 40) {
          clearInterval(timer);
          resolve(window.jQuery);
        }
      }, 50);
    });
  }

  function mountMicro(root, catalog) {
    var version = (root.getAttribute('data-bioz-version') || '2').trim();
    if (version !== '1' && version !== '2') version = '2';
    var productId = root.getAttribute('data-bioz-product-id') || String(Math.random()).slice(2);
    // Version 1 shares the catalog id with the Prime badge scroll target on PDPs.
    // Version 2 needs a unique DOM id when many list rows share one Badge_Representative.
    var idSuffix = version === '1' ? sanitizeId(catalog) : sanitizeId(catalog + '_' + productId);
    var widgetId = 'w-s-' + VENDOR_ID + '-' + idSuffix;
    var poweredId = 'bioz-w-pb-' + idSuffix;

    root.innerHTML =
      '<div id="' +
      widgetId +
      '" class="bioz-micro-badge__widget" style="width:270px;height:24px;position:relative;overflow:hidden"></div>' +
      '<div id="' +
      poweredId +
      '-div" class="bioz-micro-badge__powered" style="width:270px">' +
      '<a id="' +
      poweredId +
      '" style="font-size:12px;color:transparent" href="https://www.bioz.com/" target="_blank">' +
      '<img src="https://cdn.bioz.com/assets/favicon.png" style="width:11px;height:11px;vertical-align:baseline;padding-bottom:0;margin:0;float:none;display:none" alt="powered by bioz" /> Powered by Bioz</a></div>';

    if (typeof window.v_widget_obj !== 'function') return;

    var widgetMicroObj = new window.v_widget_obj('s', version);
    widgetMicroObj.request_catalog_number_widget_data_internal(catalog, idSuffix);
  }

  function init(root) {
    if (!root || root.getAttribute('data-bioz-ready') === 'true') return;
    var slug = resolveSlug(root);
    if (!slug) return;

    root.removeAttribute('hidden');
    root.setAttribute('data-bioz-ready', 'true');

    waitForJQuery().then(function ($) {
      if (!$) return;
      loadMicroDeps().then(function () {
        $(function () {
          mountMicro(root, slug);
        });
      });
    });
  }

  var waitingForMap = false;
  function start() {
    var roots = document.querySelectorAll('[data-bioz-micro]:not([data-bioz-ready="true"])');
    if (!roots.length) return;

    var needsMap = false;
    roots.forEach(function (root) {
      if (!(root.getAttribute('data-bioz-widget') || '').trim()) needsMap = true;
    });

    if (needsMap && !window.BIOZ_SKU_MAP && !waitingForMap) {
      waitingForMap = true;
      window.addEventListener('load', start);
      return;
    }

    roots.forEach(init);
  }

  window.BiozMicroBadge = { refresh: start };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
